import { render, staticRenderFns } from "./group-view.vue?vue&type=template&id=6e56db62&scoped=true&"
import script from "./group-view.vue?vue&type=script&lang=js&"
export * from "./group-view.vue?vue&type=script&lang=js&"
import style0 from "./group-view.vue?vue&type=style&index=0&id=6e56db62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56db62",
  null
  
)

export default component.exports